import { render, staticRenderFns } from "./OrgSelectKxy.vue?vue&type=template&id=e3db8864&"
import script from "./OrgSelectKxy.vue?vue&type=script&lang=js&"
export * from "./OrgSelectKxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports